module.exports = __webpack_public_path__ + "img/brands.f3b7c04d.png";